import Repository from "./repository";

const storage = process.env.VUE_APP_STORAGE_URL;

export default {
  index() {
    return Repository.get(`${storage}common/data/route.json`);
  },
};
